/* Aktepeler olcum: WhatsApp tiklamasi ve iletisim formu gonderimini Shopify musteri olayi olarak yayinlar.
   GA4 ozel pikseli (Ayarlar > Musteri etkinlikleri > "GA4 Aktepeler") bu olaylara abone olup Google'a iletir.
   Reklam donusumu = teklif talebi (B2B); satin alma degil. 25.10.2026 */
(function () {
  function yayinla(ad, veri) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(ad, veri); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="wa.me"], a[href^="tel:"]') : null;
    if (!a) return;
    yayinla(a.href.indexOf('wa.me') > -1 ? 'whatsapp_tiklama' : 'telefon_tiklama', { href: a.href, sayfa: location.pathname });
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && f.action.indexOf('/contact') > -1) yayinla('iletisim_formu', { sayfa: location.pathname });
  }, true);
})();
